export default __webpack_public_path__ + "static/media/Scope-6.106e9875.png";